import styled from "styled-components";

export const AuthorName = styled.span`
  font-family: Merriweather;
  font-size: 48.83px;
  font-weight: 700;
  line-height: 61.38px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: rgba(255, 255, 255, 1);
  @media (max-width: 64em) {
    text-align: center;
  }
  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 42px;
    margin-top: 10px;
  }
`;
